import React from 'react';
import { DisplayItem, moneyFormat } from 'design-system';

import {
  CoverageCatalog,
  CoverageCatalogResume,
  QuotationCoverage,
  Quotation,
} from 'data-layer-cr/dist/models';

import { getEndorsementCoverages } from 'data-layer-cr/dist/functions/quotations';
import { fullDataForCode } from 'data-layer-cr/dist/functions/coverages';

import { CardQuotation } from '../../../../../general';

const { formatMoney } = moneyFormat;

type Props = {
  quotation: Quotation;
  coverages: CoverageCatalog[];
  coverageResumes: CoverageCatalogResume[];
};

const AdditionalCoveragesCard = ({
  quotation,
  coverages,
  coverageResumes,
}: Props): JSX.Element => {
  const simplifiedCoverageList = getEndorsementCoverages(
    quotation,
    coverageResumes,
  );
  const displayItems: DisplayItem[] = [];
  simplifiedCoverageList.forEach(
    (simplifiedCoverage: QuotationCoverage): void => {
      const data = fullDataForCode(coverages, simplifiedCoverage.coverageId);
      if (typeof data !== 'undefined') {
        // If maxCost is 0 return Gratis else format maxCost
        const maxCost = !data.maxCost
          ? 'Gratis'
          : formatMoney(
              data.maxCost,
              false,
              quotation.quotationProfile.typeOfMoney,
            );

        // In the case of this types of coverages (endorsement), their data comes from
        // the catalog instead of from the quotation. The quotation only specifies which
        // one will be shown.
        displayItems.push({
          Value: data.name,
          Text: maxCost,
        });
      } else {
        // Just in case nothing is found, display empty values
        displayItems.push({
          Value: '',
          Text: '',
        });
      }
    },
  );

  return (
    <CardQuotation
      title="Beneficios de la póliza"
      decorateFooter={displayItems[0]}
    />
  );
};

export default AdditionalCoveragesCard;
